import JirouKyouka from "../../assets/combatants/superpower/jirou-kyouka.png";
import JirouKyoukaIcon from "../../assets/combatants/superpower/jirou-kyouka-icon.png";
import JirouKyoukaWin from "../../assets/combatants/superpower/jirou-kyouka-win.png";
import JirouKyoukaLose from "../../assets/combatants/superpower/jirou-kyouka-lose.png";

import OchacoUraraka from "../../assets/combatants/superpower/ochaco-uraraka.png";
import OchacoUrarakaIcon from "../../assets/combatants/superpower/ochaco-uraraka-icon.png";
import OchacoUrarakaWin from "../../assets/combatants/superpower/ochaco-uraraka-win.png";
import OchacoUrarakaLose from "../../assets/combatants/superpower/ochaco-uraraka-lose.png";

import MomoYaoyorozu from "../../assets/combatants/superpower/momo-yaoyorozu.png";
import MomoYaoyorozuIcon from "../../assets/combatants/superpower/momo-yaoyorozu-icon.png";
import MomoYaoyorozuWin from "../../assets/combatants/superpower/momo-yaoyorozu-win.png";
import MomoYaoyorozuLose from "../../assets/combatants/superpower/momo-yaoyorozu-lose.png";

import UtsushimiCamie from "../../assets/combatants/superpower/utsushimi-camie.png";
import UtsushimiCamieIcon from "../../assets/combatants/superpower/utsushimi-camie-icon.png";
import UtsushimiCamieWin from "../../assets/combatants/superpower/utsushimi-camie-win.png";
import UtsushimiCamieLose from "../../assets/combatants/superpower/utsushimi-camie-lose.png";

import AsuiTsuyu from "../../assets/combatants/superpower/asui-tsuyu.png";
import AsuiTsuyuIcon from "../../assets/combatants/superpower/asui-tsuyu-icon.png";
import AsuiTsuyuWin from "../../assets/combatants/superpower/asui-tsuyu-win.png";
import AsuiTsuyuLose from "../../assets/combatants/superpower/asui-tsuyu-lose.png";

export const seriesId = "Boku No Hero Academia";

export default {
  jirouKyouka: {
    seriesId,
    id: "jirouKyouka",
    name: "Jirou Kyouka",
    description:
      "She has a pragmatic, unenthusiastic, and teasing personality that is mostly shown to those she finds irritating. Kyoka can channel the sound of her heartbeat into it in the form of a violent vibration attack.",
    img: JirouKyouka,
    icon: JirouKyoukaIcon,
    opWinImg: JirouKyoukaWin,
    opLoseImg: JirouKyoukaLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "petite",
    eyeColor: "dark purple",
    hairColor: "purple",
    skinColor: "fair",
    height: 1,
    penisSize: 0,
    breastSize: 1,
    vaginaSize: 1,
    anusSize: 2,
    throatSize: 1,
    prefAttack: "tongue",
    prefTarget: "vagina",
    uniqueAttackText:
      "Kyoka's tongue dives inbetween xxxx's lower lips and sensually explores her inner walls, also teasing her clit.",
    roughPlayLvl: 5,
    seductionResistance: 25,
    grapplingProwess: 15,
    tongueProwess: 25,
    touchProwess: 15,
    cockProwess: 10,
    vaginaProwess: 10,
    anusProwess: 5,
    touchResistance: 15,
    breastResistance: 10,
    mouthResistance: 20,
    cockResistance: 15,
    vaginaResistance: 5,
    anusResistance: 5,
    orgasmLimit: 3,
  },
  ochacoUraraka: {
    seriesId,
    id: "ochacoUraraka",
    name: "Ochaco Uraraka",
    description:
      "Uraraka is warm and easily amused. Her power is able to remove gravity from anything she touches.",
    img: OchacoUraraka,
    icon: OchacoUrarakaIcon,
    opWinImg: OchacoUrarakaWin,
    opLoseImg: OchacoUrarakaLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "soft",
    eyeColor: "hazel",
    hairColor: "hazel",
    skinColor: "fair",
    height: 1,
    penisSize: 0,
    breastSize: 3,
    vaginaSize: 2,
    anusSize: 2,
    throatSize: 2,
    prefAttack: "touch",
    prefTarget: "cock",
    uniqueAttackText:
      "Uraraka's roughly pump xxxx's shaft, deftly kneading it in a capable attempt as extracting any cum available.",
    roughPlayLvl: -15,
    seductionResistance: 10,
    grapplingProwess: 25,
    tongueProwess: 5,
    touchProwess: 20,
    cockProwess: 10,
    vaginaProwess: 10,
    anusProwess: 15,
    touchResistance: 5,
    breastResistance: 15,
    mouthResistance: 20,
    cockResistance: 5,
    vaginaResistance: 15,
    anusResistance: 15,
    orgasmLimit: 3,
  },
  momoYaoyorozu: {
    seriesId,
    id: "momoYaoyorozu",
    name: "Momo Yaoyorozu",
    description:
      "Momo is a very prudent, dedicated person who acts as a natural leader. her power is the ability to create thigns from her skin.",
    img: MomoYaoyorozu,
    icon: MomoYaoyorozuIcon,
    opWinImg: MomoYaoyorozuWin,
    opLoseImg: MomoYaoyorozuLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "Busty",
    eyeColor: "black",
    hairColor: "black",
    skinColor: "pale",
    height: 4,
    penisSize: 0,
    breastSize: 4,
    vaginaSize: 1,
    anusSize: 3,
    throatSize: 2,
    prefAttack: "touch",
    prefTarget: "anus",
    uniqueAttackText:
      "Momo secretly summons a large dildo and uses it on xxxx's arse, digging deep and roughly.",
    roughPlayLvl: 10,
    seductionResistance: 20,
    grapplingProwess: 25,
    tongueProwess: 15,
    touchProwess: 35,
    cockProwess: 15,
    vaginaProwess: 25,
    anusProwess: 15,
    touchResistance: 15,
    breastResistance: 5,
    mouthResistance: 15,
    cockResistance: 15,
    vaginaResistance: 20,
    anusResistance: 25,
    orgasmLimit: 3,
  },
  utsushimiCamie: {
    seriesId,
    id: "utsushimiCamie",
    name: "Utsushimi Camie",
    description:
      "She is very laid back, straightforward, and tends to be quite talkative. Can create illusion producing smoke.",
    img: UtsushimiCamie,
    icon: UtsushimiCamieIcon,
    opWinImg: UtsushimiCamieWin,
    opLoseImg: UtsushimiCamieLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "curvaceous",
    eyeColor: "dark brown",
    hairColor: "fawn",
    skinColor: "pale",
    height: 2,
    penisSize: 0,
    breastSize: 4,
    vaginaSize: 2,
    anusSize: 3,
    throatSize: 3,
    prefAttack: "mouth",
    prefTarget: "breasts",
    uniqueAttackText:
      "Camie lovingly licks xxxx's tits, before suddenly biting her nipples animalistically.",
    roughPlayLvl: 25,
    seductionResistance: 20,
    grapplingProwess: 25,
    tongueProwess: 25,
    touchProwess: 15,
    cockProwess: 15,
    vaginaProwess: 25,
    anusProwess: 25,
    touchResistance: 15,
    breastResistance: 25,
    mouthResistance: 5,
    cockResistance: 15,
    vaginaResistance: 20,
    anusResistance: 25,
    orgasmLimit: 3,
  },
  asuiTsuyu: {
    seriesId,
    id: "asuiTsuyu",
    name: "Asui Tsuyu",
    description:
      "Also known as Froppy, she is a straightforward and laid-back individual who always speaks directly from her mind.",
    img: AsuiTsuyu,
    icon: AsuiTsuyuIcon,
    opWinImg: AsuiTsuyuWin,
    opLoseImg: AsuiTsuyuLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "slender",
    eyeColor: "black",
    hairColor: "dark green",
    skinColor: "pale",
    height: 1,
    penisSize: 0,
    breastSize: 3,
    vaginaSize: 2,
    anusSize: 2,
    throatSize: 4,
    prefAttack: "tongue",
    prefTarget: "vagina",
    uniqueAttackText:
      "Tsuyu's incredibly long tongue explores the depths of xxxx's pussy, teasing and tasting areas never before teased.",
    roughPlayLvl: -10,
    seductionResistance: 20,
    grapplingProwess: 25,
    tongueProwess: 45,
    touchProwess: 20,
    cockProwess: 25,
    vaginaProwess: 25,
    anusProwess: 25,
    touchResistance: 35,
    breastResistance: 25,
    mouthResistance: 50,
    cockResistance: 15,
    vaginaResistance: 45,
    anusResistance: 25,
    orgasmLimit: 3,
  },
};
